import React, { useState, createContext, useEffect, useCallback } from "react";
import { storageDelete, storageGet, storageSet } from "../services/storage";
import Cookies from "js-cookie";

const AuthContext = createContext();

const array_pendencias = {
  aviso_ferias: 0,
  recibo_ferias: 0,
  comprovante_rendimentos: 0,
  holerites: 0,
  avaliacoes: 0,
  pdi: 0,
  termos: 0,
  notificacoes: 0,
  videos: 0,
  equipamentos: 0,
  treinamentos: 0,
  publicacoes: 0,
  documentos: 0,
  problemas: 0,
  eleicoes_cipa: 0,
  escolaridade: 0,
  formularios: 0,
};

const AuthContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState({
    logado: false,
    acessos: [],
    token: null,
    verificado: false,
    cadastro_atualizado: true,
    usuario: {},
    termos_pendentes: [],
    formularios_pendentes: [],
    politicas_privacidade_pendentes: [],
  });
  const [pendencias, setPendencias] = useState(array_pendencias);

  useEffect(() => {
    carregarSessao();
  }, []);

  const carregarSessao = useCallback(async () => {
    setLoading(true);
    try {
      const value = storageGet("web_colaborador");
      const session_cookies = Cookies.get("web_colaborador");

      if (value !== null) {
        setSession({ ...JSON.parse(value), ...JSON.parse(session_cookies) });
      }
    } catch (e) {
      //erros
    }
    setLoading(false);
  }, []);

  const iniciarSessao = useCallback(async (data, remember = false) => {
    setLoading(true);
    setSession({
      logado: data.logado,
      usuario: data.usuario,
      token: data.token,
      expires: remember ? 365 : null,
      verificado: data.verificado,
      formularios_pendentes: data.formularios_pendentes,
      termos_pendentes: data.termos_pendentes,
      acessos: data.acessos,
      politicas_privacidade_pendentes: data.politicas_privacidade_pendentes,
      cadastro_atualizado: data.cadastro_atualizado,
    });

    Cookies.set(
      "web_colaborador",
      JSON.stringify({
        verificado: data.verificado,
        logado: data?.logado,
        token: data?.token,
        expires: remember ? 365 : null,
      }),
      { expires: remember ? 365 : null }
    );

    storageSet(
      "web_colaborador",
      JSON.stringify({
        usuario: data?.usuario,
        formularios_pendentes: data.formularios_pendentes,
        termos_pendentes: data.termos_pendentes,
        acessos: data.acessos,
        politicas_privacidade_pendentes: data.politicas_privacidade_pendentes,
      })
    );
    setLoading(false);
  }, []);

  const atualizarDados = useCallback(
    async (usuario, termos, formularios, politica, acessos, cadastro_atualizado) => {
      setSession((state) => ({
        ...state,
        usuario: usuario,
        termos_pendentes: termos,
        formularios_pendentes: formularios,
        politicas_privacidade_pendentes: politica,
        acessos: acessos,
        cadastro_atualizado: cadastro_atualizado,
      }));

      storageSet(
        "web_colaborador",
        JSON.stringify({
          usuario: usuario,
          termos_pendentes: termos,
          formularios_pendentes: formularios,
          politicas_privacidade_pendentes: politica,
          acessos: acessos,
          cadastro_atualizado: cadastro_atualizado,
        })
      );
    },
    [session]
  );

  const encerrarSessao = useCallback(async () => {
    setSession((state) => ({ ...state, logado: false, usuario: {} }));
    storageDelete("web_colaborador");
    Cookies.remove("web_colaborador");
  }, []);

  const verificar = useCallback(
    async (verificacao) => {
      setSession((state) => ({ ...state, verificado: verificacao }));
      Cookies.set(
        "web_colaborador",
        JSON.stringify({
          logado: session?.logado,
          token: session?.token,
          verificado: verificacao,
        }),
        { expires: session?.expires }
      );
    },
    [session]
  );

  const atualizarPendencias = useCallback(async (dados_pendencias) => {
    setPendencias(dados_pendencias);
  }, []);

  const atualizarTermos = useCallback(
    async (termos) => {
      setSession((state) => ({ ...state, termos_pendentes: termos }));
      storageSet(
        "web_colaborador",
        JSON.stringify({
          usuario: session?.usuario,
          formularios_pendentes: session?.formularios,
          politicas_privacidade_pendentes: session?.politica,
          acessos: session?.acessos,
          termos_pendentes: termos,
        })
      );
    },
    [session]
  );

  const atualizarFormularios = useCallback(
    async (formularios) => {
      setSession((state) => ({ ...state, formularios_pendentes: formularios }));

      storageSet(
        "web_colaborador",
        JSON.stringify({
          usuario: session?.usuario,
          politicas_privacidade_pendentes: session?.politica,
          acessos: session?.acessos,
          termos_pendentes: session?.termos,
          formularios_pendentes: formularios,
        })
      );
    },
    [session]
  );

  const atualizarPoliticaPrivacidade = useCallback(
    async (politica_privacidade) => {
      setSession((state) => ({ ...state, politicas_privacidade_pendentes: politica_privacidade }));
      storageSet(
        "web_colaborador",
        JSON.stringify({
          usuario: session?.usuario,
          acessos: session?.acessos,
          termos_pendentes: session?.termos,
          formularios_pendentes: session?.formularios,
          politicas_privacidade_pendentes: politica_privacidade,
        })
      );
    },
    [session]
  );

  const atualizarUsuario = useCallback(
    async (dados) => {
      setSession((state) => ({ ...state, usuario: dados, cadastro_atualizado: true }));
      storageSet(
        "web_colaborador",
        JSON.stringify({
          acessos: session?.acessos,
          termos_pendentes: session?.termos,
          formularios_pendentes: session?.formularios,
          politicas_privacidade_pendentes: session?.politica_privacidade,
          cadastro_atualizado: true,
          usuario: dados,
        })
      );
    },
    [session]
  );

  const verificarAcesso = useCallback(
    (acesso = []) => {
      const acessos = session?.acessos;

      if (Array.isArray(acesso)) {
        if (
          acessos?.find((e) => {
            return acesso.find((a) => a === e.acesso);
          })
        ) {
          return true;
        }
      } else {
        if (acessos?.find((e) => e.acesso === acesso)) {
          return true;
        }
      }

      return false;
    },
    [session]
  );

  return (
    <AuthContext.Provider
      value={{
        session,
        loading,
        pendencias,
        verificar,
        iniciarSessao,
        encerrarSessao,
        atualizarUsuario,
        atualizarTermos,
        atualizarFormularios,
        verificarAcesso,
        atualizarDados,
        atualizarPendencias,
        atualizarPoliticaPrivacidade,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContextProvider, AuthContext };
